import { render, staticRenderFns } from "./ContactUsMain.vue?vue&type=template&id=6b820af0&scoped=true"
import script from "./ContactUsMain.vue?vue&type=script&lang=js"
export * from "./ContactUsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b820af0",
  null
  
)

export default component.exports